import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator"; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Analytics from '@/utils/Analytics';
import { mapActions } from 'vuex';
import throttle from '@/utils/throttle';
import Cookie from 'drip/utils/cookie';
import axios from 'axios';
import KNB from 'KNB';
import Event from 'drip/event';
import Geo from 'drip/geo';
import Store from 'drip/store';
import Drip from 'drip';
import bottomTab from 'drip/components/bottom-tab';
import URL from 'drip/utils/url';
import SearchBar from '@/components/home/search-bar';
import TodayLook from '@/components/home/today-look';
import CategoryList from '@/components/home/CategoryList';
import ArtistList from '@/components/home/ArtistList';
import RecommendList from '@/components/home/RecommendList';
import AdBanner from '@/components/home/AdBanner';
import WhatLook from '@/components/home/WhatLook';
import Top from '@/components/home/Top';
import Brand from '@/components/home/Brand';
import SideIcon from '@/components/home/SideIcon';
import YellowStrip from '@/components/common/YellowStrip';
import Calendar from '@/components/home/Calendar';
import { GET_YELLOW_STRIP } from '@/constants/home';
import { API_TOP_LIST } from '@/apis';
import { isProd } from '@/config';
import { fetchMaoyanADList, fetchShowRecommendList, fetchTodayList, fetchArtistList, fetchMyShowAds, fetchCalendarList, fetchBrandList, getABtest } from '@/request/home';
import ACTIVITY_TAG_VALUE from '@/constants/activityTagValue';
import cmblapi from '@myfe/cmblapi';
import { matchFeatureUrl } from '@/apis';
var ACTIVITY_TAG = Drip.activityTag;
var MIDDLE_BANNER = 'MIDDLE_BANNER';
var TODAY_SALE = 'TODAY_SALE';
var GOLDEN_ICON = 'GOLDEN_ICON';
var ICON_SUBSCRIPT = 'ICON_SUBSCRIPT';
var WHAT_LOOK = 'WHAT_LOOK';
var STAR = 'STAR';
var SIDEBAR = 'SIDEBAR';
var RECOMMENDATION_1 = 'RECOMMENDATION_1';
var RECOMMENDATION_2 = 'RECOMMENDATION_2';
var RECOMMENDATION_3 = 'RECOMMENDATION_3';
var NEW_GOLDEN_ICON = 'NEW_GOLDEN_ICON';
var positionMap = {
  GOLDEN_ICON: 1219,
  // 金刚位
  ICON_SUBSCRIPT: 1230,
  // 金刚位角标
  TODAY_SALE: 1231,
  // 今日必抢
  MIDDLE_BANNER: 1221,
  // 中通位
  STAR: 1220,
  // 追星位
  WHAT_LOOK: 1262,
  // 榜单
  SIDEBAR: 1233,
  // 侧边栏
  RECOMMENDATION_1: 1232,
  // 推荐位1
  RECOMMENDATION_2: 1234,
  // 推荐位2
  RECOMMENDATION_3: 1235,
  // 推荐位3
  NEW_GOLDEN_ICON: 2441
};
var leftHeight = 0,
    rightHeight = 0;
export default {
  name: 'home-refactor',
  components: {
    SearchBar: SearchBar,
    CategoryList: CategoryList,
    TodayLook: TodayLook,
    AdBanner: AdBanner,
    ArtistList: ArtistList,
    WhatLook: WhatLook,
    RecommendList: RecommendList,
    SideIcon: SideIcon,
    YellowStrip: YellowStrip,
    Calendar: Calendar,
    Top: Top,
    Brand: Brand
  },
  data: function data() {
    return {
      isAbTest: false,
      isMaoyanI: null,
      locCity: {},
      recommendTitle: Drip.UA.IS_GEWARA ? '精彩推荐' : '为你推荐',
      originPageScrollTop: 0,
      pageScrollTop: 0,
      // 金刚位
      goldenList: null,
      // 今日必抢推荐列表
      todayLookList: [],
      todayLookMap: {},
      // 日历模块
      weekCalendarList: [],
      weekCalendar12: [],
      monthCalendarList: [],
      // 中通广告位列表
      adList: [],
      // 艺人大咖推荐列表
      artistList: [],
      // 榜单列表
      topList: [],
      // 品牌馆列表
      brandList: [],
      // 项目推荐列表
      recommendList: [],
      recommendIdList: [],
      // 投放 为你推荐
      // 侧边栏推荐列表
      sideList: [],
      // 推荐项目列表是否在加载中
      isLoading: false,
      // 是否有更多的推荐项目
      hasMore: false,
      // 推荐列表的当前页
      pageNo: 1,
      // 左项推荐列表
      recommendListLeft: [],
      // 右项推荐里列表
      recommendListRight: [],
      // 左项推荐列表默认颜色值
      DEFAULT_IMG_BG_LEFT_COLOR: ["#FFF2F1", "#FFFBF0", "#E9F6FF", "#F5F5F5", "#FFF1E6", "#ECF8F5", "#F6F1FF"],
      // 右项推荐列表默认颜色值
      DEFAULT_IMG_BG_RIGHT_COLOR: ["#FFF1E6", "#ECF8F5", "#F6F1FF", "#FFF2F1", "#FFFBF0", "#E9F6FF", "#F5F5F5"],
      isMSite: Boolean // 是否m站

    };
  },
  computed: {
    yellowStripInfo: function yellowStripInfo() {
      var _ref = this.$store.state.home || {},
          yellowStripInfo = _ref.yellowStripInfo;

      return yellowStripInfo;
    },
    isShowTop: function isShowTop() {
      return this.topList && this.topList.length > 1;
    }
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var redirectUrl, url, isConsoleDebug, now, expires, istest, _now, _expires, isAbTest;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.isMaoyanI = _this.isMaoyanIFn();
              /** 招行定制 */

              if (!Drip.UA.IS_CMBAPP) {
                _context.next = 9;
                break;
              } //设置招行猫眼演出的首页


              try {
                cmblapi.applet({
                  api: 'setHomepage',
                  params: {
                    url: 'https://show.maoyan.com/qqw/'
                  }
                });
              } catch (error) {} // r=redirectUrl，招行直接重定向到具体页面


              redirectUrl = URL.getQuery('r') || URL.getHashQuery('r');

              if (!redirectUrl) {
                _context.next = 9;
                break;
              }

              bottomTab.hide();
              url = decodeURIComponent(redirectUrl);
              location.replace(url);
              return _context.abrupt("return");

            case 9:
              if (_this.isMaoyanI) {
                bottomTab();
                bottomTab.show();
              }
              /** 线上debug console */


              isConsoleDebug = Cookie.get('_debugconsole');

              if (!isConsoleDebug && window.location.hash.indexOf('debugconsole=1') !== -1) {
                // 不存在 且以特定路径进入
                now = new Date().getTime();
                expires = now + 3600 * 3 * 1000;
                expires = new Date(expires);
                Cookie.set('_debugconsole', 'true', {
                  path: '/',
                  expires: expires.toGMTString()
                });
              }
              /** 线上debug coonsole */

              /** 压力测试专用 */


              istest = Cookie.get('_istest');

              if (!istest && window.location.hash.indexOf('test=1') !== -1) {
                // 不存在 且以特定路径进入
                _now = new Date().getTime();
                _expires = _now + 3600 * 3 * 1000;
                _expires = new Date(_expires);
                Cookie.set('_istest', 'true', {
                  path: '/',
                  expires: _expires.toGMTString()
                });
              }
              /** 压力测试专用 */
              // 清除运营位标志位


              _this.deleteActivityTag();

              _this.Env.setTitle('演出/玩乐');

              _this.bottoming = throttle(_this.bottoming);
              _this.scroll = _this.throttle(_this.scroll, 300);
              window.addEventListener('scroll', _this.bottoming, false);
              window.addEventListener('scroll', _this.scroll, false);

              _this[GET_YELLOW_STRIP]();

              _this.isMSite = Drip.UA.IS_QQWALLET;
              _context.next = 24;
              return _this.getIsAbTest();

            case 24:
              isAbTest = _context.sent;
              _this.isAbTest = isAbTest;
              window.seedAction({
                evt: "view",
                bid: "b_movie_usyyk9ev_mv",
                custom: {
                  stid: isAbTest ? 1 : 0,
                  custom: {
                    stid: isAbTest ? 1 : 0
                  }
                }
              });

            case 27:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.scroll, false);
    window.removeEventListener('scroll', this.bottoming, false);
    Event.off('cityChange', this.handleCityChange);
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.isMaoyanI && bottomTab.hide();
    next();
  },
  beforeCreate: function beforeCreate() {
    KNB.ready(function () {
      Geo.getCity();
      Geo.getLocCity();
    });
  },
  mounted: function mounted() {
    this.init();
    Event.on('cityChange', this.handleCityChange);
  },
  methods: Object.assign({}, mapActions([GET_YELLOW_STRIP]), {
    isMaoyanIFn: function isMaoyanIFn() {
      return ['qqwallet', 'maoyan_i', 'cmb_app'].includes(Drip.constant.uaInfo.appName);
    },
    bottoming: function bottoming() {
      var page = this.$refs.homepage;

      if (!this.isLoading && this.hasMore && Number(window.scrollY) + Number(window.innerHeight) >= Number(page.clientHeight) - 50) {
        // 触底, 有更多且不在加载中, 加载下一页
        this.getRecommendList(this.pageNo + 1);
      }
    },
    // 监听页面滚动事件
    scroll: function scroll() {
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop; // 窗口可视范围高度

      var clientHeight = window.innerHeight || Math.min(document.documentElement.clientHeight, document.body.clientHeight);
      var page = this.$refs.homepage; // 滑动至 3倍 clientHeight + 触底判断

      if (Math.round(scrollTop / clientHeight) >= this.pageNo * 3 && this.hasMore) {
        this.getRecommendList(this.pageNo + 1);
      }
    },
    // 截流
    throttle: function throttle(fn, gapTime) {
      if (gapTime === null || gapTime === undefined) {
        gapTime = 1500;
      }

      var _lastTime = null;
      return function () {
        var _nowTime = +new Date();

        if (_nowTime - _lastTime > gapTime || !_lastTime) {
          _lastTime = _nowTime;
          fn.apply(this, arguments); // 将this和参数传给原函数
        }
      };
    },
    init: function init() {
      this.getPositionList();
      this.initDataReport();
    },
    // 初始化页面打点
    initDataReport: function initDataReport() {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                Analytics('c_movie_aq5xt2v5', Drip.User.userId, {}, undefined, true);

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    handleCityChange: function handleCityChange(city) {
      var _this2 = this;

      setTimeout(function () {
        _this2.init();
      }, 500);
    },
    // 清除运营位标志位
    deleteActivityTag: function deleteActivityTag() {
      var utm = {};
      var oldUtmCookie = Cookie.get('_lx_utm');

      if (oldUtmCookie) {
        utm = URL.parseQuery(oldUtmCookie);
        Object.keys(utm).forEach(function (key) {
          if (key === ACTIVITY_TAG.STATS_TAG) {
            delete utm[key];
          }
        });
      }

      if (window.resetUTMAction) {
        window.resetUTMAction(utm);
      }
    },
    touchStart: function touchStart() {
      this.originPageScrollTop = document.body.scrollTop || document.documentElement.scrollTop;
    },
    touchMove: function touchMove() {
      this.pageScrollTop = document.body.scrollTop || document.documentElement.scrollTop;
    },
    // 项目去重
    projectUnion: function projectUnion(list) {
      list = list || [];
      var idList = [];
      return list.filter(function (a) {
        var performanceId = a.performanceId;

        if (performanceId) {
          var hasFlag = idList.includes(performanceId);
          idList.push(performanceId);
          return !hasFlag;
        }

        return true;
      });
    },
    // 设置默认的海报图
    defaultPoster: function defaultPoster(list) {
      var poster = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'https://p0.meituan.net/myvideodistribute/96c418c85d3735b8b54507ce7fbd17432789.png';
      return list.map(function (a) {
        a.posterUrl = a.posterUrl || poster;
        return a;
      });
    },
    // 跳转今日必抢页面
    gotoTodayPage: function gotoTodayPage() {
      this.go('/today?categoryId=0');
      window.seedAction({
        bid: 'b_movie_fshak929_mc'
      });
    },
    // 获取榜单列表
    fetchTopList: function fetchTopList() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _yield$_this3$$http$g, code, data;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return _this3.$http.get(API_TOP_LIST);

              case 3:
                _yield$_this3$$http$g = _context3.sent;
                code = _yield$_this3$$http$g.code;
                data = _yield$_this3$$http$g.data;

                if (!(code !== 200 || !data)) {
                  _context3.next = 8;
                  break;
                }

                return _context3.abrupt("return");

              case 8:
                _this3.topList = data.map(function (top) {
                  top.performances.forEach(function (show) {
                    show.posterUrl = show.posterUrl || 'https://p0.meituan.net/myvideodistribute/96c418c85d3735b8b54507ce7fbd17432789.png';
                    show.reasonTxt = (show.brightPointList || []).filter(function (_ref2) {
                      var title = _ref2.title;
                      return title;
                    }).map(function (_ref3) {
                      var title = _ref3.title;
                      return title;
                    })[0] || '';
                    show.lowestPrice = (show.priceRange || '').split('-')[0] || '价格待定';
                    show.dataSeed = {
                      bid: 'b_movie_x8af6gaf_mc',
                      viewBid: 'b_movie_x8af6gaf_mv',
                      custom: {
                        performance_id: show.performanceId,
                        billboard_id: top.rankId
                      }
                    };
                  });
                  return Object.assign({}, top);
                });
                _context3.next = 13;
                break;

              case 11:
                _context3.prev = 11;
                _context3.t0 = _context3["catch"](0);

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[0, 11]]);
      }))();
    },
    // 获取今日必抢的列表
    getTodayList: function getTodayList() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var data, listMap, i;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return fetchTodayList();

              case 2:
                data = _context4.sent;
                listMap = {};

                if (data && data.length > 0) {
                  _context4.next = 6;
                  break;
                }

                return _context4.abrupt("return");

              case 6:
                i = 0; // 今日必抢的打点数据

                data.forEach(function (a, index) {
                  // 设置默认的海报图
                  a.posterUrl = a.posterUrl || 'https://p0.meituan.net/myvideodistribute/96c418c85d3735b8b54507ce7fbd17432789.png';
                  a.hasScore = a.score && a.score !== '0.0' && a.score !== '0';

                  if (a) {
                    a.dataSeed = {
                      bid: 'b_movie_41c8nv4n_mc',
                      viewBid: 'b_movie_41c8nv4n_mv',
                      custom: {
                        performance_id: a.performanceId,
                        index: index
                      }
                    };

                    if (a.reachRobStandard) {
                      listMap[a.performanceId] = a;
                    } else {
                      if (i < 12) {
                        listMap[a.performanceId] = a;
                        i++;
                      }
                    }
                  }
                });
                _this4.todayLookList = data;
                _this4.todayLookMap = listMap;

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    // 获取日历模块列表
    getCalendarList: function getCalendarList(type) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _yield$fetchCalendarL, code, data;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return fetchCalendarList({
                  timeFilterType: type,
                  pageSize: 40
                });

              case 3:
                _yield$fetchCalendarL = _context5.sent;
                code = _yield$fetchCalendarL.code;
                data = _yield$fetchCalendarL.data;

                if (!(code !== 200 || !data)) {
                  _context5.next = 8;
                  break;
                }

                return _context5.abrupt("return");

              case 8:
                data.forEach(function (a, index) {
                  // 设置默认的海报图
                  a.posterUrl = a.posterUrl || 'https://p0.meituan.net/myvideodistribute/96c418c85d3735b8b54507ce7fbd17432789.png';
                  a.dataSeed = {
                    bid: 'b_movie_hgsz1xj6_mc',
                    viewBid: 'b_movie_hgsz1xj6_mv',
                    custom: {
                      performance_id: a.performanceId
                    }
                  };
                });

                if (type === 4) {
                  _this5.weekCalendarList = data.filter(function (item) {
                    return _this5.todayLookMap[item.performanceId] === undefined;
                  });
                  _this5.weekCalendar12 = _this5.weekCalendarList.slice(0, 12);

                  _this5.getCalendarList(5);
                } else {
                  _this5.monthCalendarList = data.filter(function (item) {
                    return _this5.todayLookMap[item.performanceId] === undefined && _this5.weekCalendar12.find(function (week) {
                      return week.performanceId === item.performanceId;
                    }) === undefined;
                  });
                }

                _context5.next = 14;
                break;

              case 12:
                _context5.prev = 12;
                _context5.t0 = _context5["catch"](0);

              case 14:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[0, 12]]);
      }))();
    },
    // 获取推荐的项目列表
    getRecommendList: function getRecommendList(pageNo) {
      var _arguments = arguments,
          _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var pageSize, _yield$fetchShowRecom, code, data, paging, recommendListLeft, recommendListRight, recommendListLeftTemp, recommendListRightTemp, dataTemp, index, hasMore;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                pageSize = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : 20;

                if (!_this6.isLoading) {
                  _context6.next = 3;
                  break;
                }

                return _context6.abrupt("return");

              case 3:
                // 加载更多的打点数据
                window.seedAction({
                  bid: 'b_movie_sw5v0dfh_mc'
                });
                _this6.isLoading = true;
                _context6.next = 7;
                return fetchShowRecommendList(pageNo, pageSize);

              case 7:
                _yield$fetchShowRecom = _context6.sent;
                code = _yield$fetchShowRecom.code;
                data = _yield$fetchShowRecom.data;
                paging = _yield$fetchShowRecom.paging;

                if (!(code !== 200)) {
                  _context6.next = 13;
                  break;
                }

                return _context6.abrupt("return");

              case 13:
                data = data || [];
                data.forEach(function (a) {
                  a.jumpUrl = "/myshow/#/detail/".concat(a.performanceId);
                });
                recommendListLeft = _this6.recommendListLeft, recommendListRight = _this6.recommendListRight;
                recommendListLeftTemp = recommendListLeft || [];
                recommendListRightTemp = recommendListRight || [];

                if (!(pageNo !== 1)) {
                  _context6.next = 48;
                  break;
                }

                dataTemp = _this6.projectUnion(data); // 列表去重

                dataTemp = dataTemp.filter(function (a) {
                  return !_this6.recommendIdList.includes("".concat(a.performanceId));
                }); // 设置默认海报图

                dataTemp = _this6.defaultPoster(dataTemp);
                index = 0;

              case 23:
                if (!(index < dataTemp.length)) {
                  _context6.next = 48;
                  break;
                }

                try {
                  // 打点
                  if (!dataTemp[index].dataSeed) {
                    // 项目的打点
                    dataTemp[index].dataSeed = {
                      bid: 'b_movie_lrqkce7a_mc',
                      viewBid: 'b_movie_lrqkce7a_mv',
                      custom: {
                        type: dataTemp[index].discountTag ? 1 : 0,
                        index: index,
                        custom: {
                          performance_id: dataTemp[index].performanceId
                        }
                      }
                    };
                  }
                } catch (e) {}

                if (!(index === Math.round((dataTemp.length - 1) / 2))) {
                  _context6.next = 31;
                  break;
                }

                _context6.next = 28;
                return _this6.getBoxHeight(recommendListLeftTemp, recommendListRightTemp);

              case 28:
                leftHeight <= rightHeight ? recommendListLeftTemp.push(dataTemp[index]) : recommendListRightTemp.push(dataTemp[index]);
                _context6.next = 45;
                break;

              case 31:
                if (!(index !== dataTemp.length - 1 && index % 2 === 0)) {
                  _context6.next = 35;
                  break;
                }

                recommendListLeftTemp.push(dataTemp[index]);
                _context6.next = 45;
                break;

              case 35:
                if (!(index !== dataTemp.length - 1 && index % 2 === 1)) {
                  _context6.next = 39;
                  break;
                }

                recommendListRightTemp.push(dataTemp[index]);
                _context6.next = 45;
                break;

              case 39:
                if (!(index === dataTemp.length - 1)) {
                  _context6.next = 45;
                  break;
                } // 在最后一项判断，左右列表高度，选择添加进哪边


                hasMore = paging.hasMore;

                if (hasMore) {
                  _context6.next = 45;
                  break;
                }

                _context6.next = 44;
                return _this6.getBoxHeight(recommendListLeftTemp, recommendListRightTemp);

              case 44:
                leftHeight <= rightHeight ? recommendListLeftTemp.push(dataTemp[index]) : recommendListRightTemp.push(dataTemp[index]);

              case 45:
                index++;
                _context6.next = 23;
                break;

              case 48:
                // this.recommendList = recommendList
                _this6.recommendListLeft = recommendListLeftTemp;
                _this6.recommendListRight = recommendListRightTemp;
                _this6.isLoading = false;

                if (paging) {
                  _this6.pageNo = paging.pageNo;
                  _this6.hasMore = paging.hasMore;
                }

              case 52:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    // 获取艺人列表
    getArtistList: function getArtistList() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var data;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return fetchArtistList();

              case 2:
                data = _context7.sent;
                _this7.artistList = data.filter(function (a) {
                  return !!a;
                }).map(function (a, index) {
                  a.mainImg = a.headUrl || 'https://p0.meituan.net/scarlett/2b130486b1c209d988544b9a5cc454ff4719.png';
                  a.jumpUrl = "/artist?ipId=".concat(a.id);
                  a.rightTopTitle = a.updateType > 0 ? 'NEW' : '';
                  a.mainTitle = a.celebrityName || '';
                  a.leftBottomTitle = a.concern;
                  a.dataSeed = {
                    bid: 'b_movie_g14eeccl_mc',
                    viewBid: 'b_movie_n60r9fvn_mv',
                    custom: {
                      celebrity_id: a.celebrityId,
                      index: index
                    }
                  };
                  return a;
                });

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    // 获取品牌推荐列表
    getBrandList: function getBrandList() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var data, colorClassArr;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return fetchBrandList();

              case 2:
                data = _context8.sent;
                colorClassArr = ['pink', 'yellow', 'blue'];
                _this8.brandList = data.filter(function (a) {
                  return !!a;
                }).map(function (a, index) {
                  a.showUrls = a.showUrls || [];

                  if (a.showUrls.length <= 3) {
                    a.showUrls = a.showUrls.concat([0, 0, 0].slice(0, 3 - a.showUrls.length));
                  } else {
                    a.showUrls = a.showUrls.slice(0, 3);
                  }

                  if (index < 3) {
                    a.bgColor = colorClassArr[index];
                  } else {
                    a.bgColor = colorClassArr[Math.floor(Math.random() * 3)];
                  }

                  a.dataSeed = {
                    bid: 'b_movie_ch1ic4jg_mc',
                    viewBid: 'b_movie_ch1ic4jg_mv',
                    custom: {
                      brand_id: a.id
                    }
                  };
                  return a;
                });

              case 5:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }))();
    },
    getBoxHeight: function getBoxHeight(recommendListLeft, recommendListRight) {
      var _this9 = this;

      return new Promise(function (resolve, reject) {
        _this9.recommendListLeft = recommendListLeft;
        _this9.recommendListRight = recommendListRight; // DOM 还没有更新

        _this9.$nextTick(function () {
          // DOM 现在更新了
          // `this` 绑定到当前实例
          leftHeight = this.$el.querySelector('#left') && this.$el.querySelector('#left').getBoundingClientRect().height;
          rightHeight = this.$el.querySelector('#right') && this.$el.querySelector('#right').getBoundingClientRect().height;
          resolve();
        });
      });
    },
    getGoldenList: function getGoldenList(arr) {
      var idSet = [];
      return arr.filter(function (_ref4) {
        var categoryId = _ref4.categoryId,
            labelId = _ref4.labelId,
            _isAbTest = _ref4._isAbTest;
        if (_isAbTest) return true;
        var idKey = "categoryId=".concat(categoryId, "&labelId=").concat(labelId);

        if (idSet.includes(idKey)) {
          return false;
        }

        idSet.push(idKey);
        return true;
      }).map(function (a, index) {
        var categoryId = a.categoryId,
            labelId = a.labelId,
            _isAbTest = a._isAbTest,
            positonType = a.positonType,
            mainContent = a.mainContent;
        var jumpUrl = "/list/".concat(categoryId, "?labelId=").concat(labelId || 0);
        a.jumpUrl = jumpUrl;
        a.mainTitle = a.positionName;

        if (_isAbTest) {
          // positonType:1项目2活动3小程序原生
          if (Number(positonType) === 1) a.jumpUrl = "/detail/".concat(mainContent);
          if (Number(positonType) === 2) a.jumpUrl = mainContent;
        } // 金刚位的打点


        a.dataSeed = {
          bid: a._isAbTest ? 'b_movie_5hyac3rx_mc' : 'b_movie_mh9j6ixg_mc',
          viewBid: a._isAbTest ? 'b_movie_5hyac3rx_mv' : 'b_movie_mh9j6ixg_mv',
          custom: {
            category_id: categoryId,
            index: index
          }
        };
        return a;
      });
    },
    getIsAbTest: function getIsAbTest() {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var _Drip$constant$uaInfo, IS_MEITUAN, IS_MAOYAN, IS_DIANPING, myUUid, filterId, olapeId, layerId, _yield$axios$get, code, data;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                // if(!isProd) {
                //   return true
                // }
                _Drip$constant$uaInfo = Drip.constant.uaInfo, IS_MEITUAN = _Drip$constant$uaInfo.IS_MEITUAN, IS_MAOYAN = _Drip$constant$uaInfo.IS_MAOYAN, IS_DIANPING = _Drip$constant$uaInfo.IS_DIANPING;

                if (!(IS_MEITUAN || IS_MAOYAN || IS_DIANPING)) {
                  _context9.next = 30;
                  break;
                }

                _context9.next = 4;
                return Drip.getUuid();

              case 4:
                myUUid = _context9.sent;
                filterId = myUUid;
                olapeId = 566;
                layerId = 0;

                if (IS_MEITUAN) {
                  layerId = 141;
                }

                if (IS_MAOYAN) {
                  layerId = 139;
                }

                if (IS_DIANPING) {
                  layerId = 142;
                }

                if (isProd) {
                  olapeId = 64;

                  if (IS_MEITUAN) {
                    layerId = 208;
                  }

                  if (IS_MAOYAN) {
                    layerId = 206;
                  }

                  if (IS_DIANPING) {
                    layerId = 209;
                  }
                }

                _context9.prev = 12;
                _context9.next = 15;
                return axios.get("".concat(matchFeatureUrl, "?olapeId=").concat(olapeId, "&layerId=").concat(layerId, "&filterId=").concat(filterId));

              case 15:
                _yield$axios$get = _context9.sent;
                code = _yield$axios$get.code;
                data = _yield$axios$get.data;

                if (!(code === 200)) {
                  _context9.next = 22;
                  break;
                }

                return _context9.abrupt("return", data);

              case 22:
                return _context9.abrupt("return", false);

              case 23:
                _context9.next = 28;
                break;

              case 25:
                _context9.prev = 25;
                _context9.t0 = _context9["catch"](12);
                return _context9.abrupt("return", false);

              case 28:
                _context9.next = 31;
                break;

              case 30:
                return _context9.abrupt("return", false);

              case 31:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, null, [[12, 25]]);
      }))();
    },
    sortGoldenList: function sortGoldenList(goldenList, _goldenList) {
      var allInfo = {
        mainTitle: '全部',
        mainImg: 'https://obj.pipi.cn/festatic/common/image/c4ddd841d8c7f43dcd29c80e4038254c.png',
        jumpUrl: "/list/0?labelId=0",
        dataSeed: {
          bid: 'b_movie_mh9j6ixg_mc',
          viewBid: 'b_movie_mh9j6ixg_mv',
          custom: {
            category_id: 0,
            index: goldenList.length
          }
        }
      };
      var leftGoldenList = goldenList.slice(0, 10);
      var leftMidIndex = Math.ceil(leftGoldenList.length / 2);
      var leftIndex = 0;

      while (leftIndex < leftMidIndex) {
        _goldenList.push([leftGoldenList[leftIndex], leftGoldenList[leftIndex + leftMidIndex] || allInfo]);

        leftIndex++;
      }

      var rightGoldenList = goldenList.slice(10);

      if (rightGoldenList.length > 0) {
        var rightMidIndex = Math.ceil(rightGoldenList.length / 2);
        var rightIndex = 0;

        while (rightIndex < rightMidIndex) {
          _goldenList.push([rightGoldenList[rightIndex], rightGoldenList[rightIndex + rightMidIndex] || allInfo]);

          rightIndex++;
        }
      }
    },
    // 获取资源位列表
    getPositionList: function getPositionList() {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        var totalList, goldenItem, newGoldenItem, goldenList, _adVOList, iconSubscriptItem, list, _goldenList, bannerItem, adList, adVOList, maoyanAd, ad, sideItem, recommendIdList, positionAdMap, recommendAds, projectList, _ref6, data, code, paging, attrMaps, item3, resouce, item2, _resouce, item1, _resouce2, recommendList, recommendListLeft, recommendListRight, index;

        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _this10.$loading('加载中...'); // 今日必抢


                _context10.next = 3;
                return _this10.getTodayList();

              case 3:
                // 获取榜单列表
                _this10.fetchTopList(); // 获取日历模块


                _this10.getCalendarList(4); // 获取艺人大咖


                _this10.getArtistList(); // 获取品牌馆


                _this10.getBrandList();

                _context10.next = 9;
                return Promise.all([fetchMyShowAds(), fetchMaoyanADList(), fetchShowRecommendList(1, 20)]);

              case 9:
                totalList = _context10.sent;

                _this10.$loading.close(); // 金刚位的处理


                goldenItem = totalList[0] && (totalList[0].goldenAds || []).find(function (a) {
                  return a.positionId === positionMap[GOLDEN_ICON];
                });
                newGoldenItem = totalList[0] && (totalList[0].goldenAds || []).find(function (a) {
                  return a.positionId === positionMap[NEW_GOLDEN_ICON];
                });
                goldenList = [];

                if (_this10.isAbTest) {
                  if (goldenItem && newGoldenItem) {
                    _adVOList = _toConsumableArray(goldenItem.adVOList);
                    newGoldenItem.adVOList.forEach(function (t) {
                      return t._isAbTest = true;
                    });

                    _adVOList.splice.apply(_adVOList, [8, 0].concat(_toConsumableArray(newGoldenItem.adVOList)));

                    goldenList = _this10.getGoldenList(_adVOList);
                  }
                } else {
                  if (goldenItem) {
                    goldenList = _this10.getGoldenList(goldenItem.adVOList);
                  }
                } // 金刚位角标的处理


                iconSubscriptItem = totalList[0] && (totalList[0].goldenAds || []).find(function (a) {
                  return a.positionId === positionMap[ICON_SUBSCRIPT];
                });

                if (iconSubscriptItem) {
                  list = iconSubscriptItem.adVOList.map(function (_ref5) {
                    var frame = _ref5.frame,
                        mainText = _ref5.mainText;
                    return {
                      frame: frame,
                      mainText: mainText
                    };
                  });
                  goldenList.forEach(function (a, i) {
                    var subIconitem = list[i];

                    if (subIconitem) {
                      a.rightTopTitle = subIconitem.mainText;
                    }
                  });
                }

                if (_this10.isAbTest) {
                  _goldenList = [];

                  _this10.sortGoldenList(goldenList, _goldenList);

                  _this10.goldenList = _goldenList;
                } else {
                  goldenList.forEach(function (t, i) {
                    if (i >= 8) {
                      delete t.rightTopTitle;
                    }
                  });
                  _this10.goldenList = goldenList;
                } // 中通位的处理


                bannerItem = totalList[0] && (totalList[0].middleBannerAds || []).find(function (a) {
                  return a.positionId === positionMap[MIDDLE_BANNER];
                });

                if (bannerItem) {
                  adList = [];
                  adVOList = bannerItem.adVOList;
                  adList = adVOList.map(function (a, index) {
                    var positonType = a.positonType,
                        mainContent = a.mainContent,
                        mainImg = a.mainImg;
                    var jumpUrl = '';

                    if (positonType === '2') {
                      // 活动
                      jumpUrl = mainContent;
                    } else if (positonType === '1') {
                      // 项目id
                      jumpUrl = "/myshow/#/detail/".concat(mainContent);
                    }

                    a.jumpUrl = jumpUrl; // 中通的打点

                    a.dataSeed = {
                      bid: 'b_movie_db2gl1zk_mc',
                      viewBid: 'b_movie_db2gl1zk_mv',
                      custom: {
                        index: index
                      }
                    };
                    return a;
                  }); // 电影猫眼的广告位

                  maoyanAd = totalList[1];

                  if (maoyanAd && maoyanAd[0]) {
                    ad = maoyanAd[0];
                    ad.jumpUrl = ad.link;
                    ad.mainImg = ad.image.replace(/^(http:\/\/)/g, 'https://'); // 猫眼广告的打点

                    ad.dataSeed = {
                      cid: 'c_vwmiv52u',
                      bid: 'b_z3wg6f7b',
                      viewBid: 'b_8b99ppoq',
                      custom: {
                        positionId: ad.positionId,
                        ad_id: ad.adId,
                        materialId: ad.materialId,
                        ci: Drip.constant.cityId
                      }
                    };
                    adList.unshift(ad);
                  }

                  _this10.adList = adList;
                } // 侧边栏的处理


                sideItem = totalList[0] && (totalList[0].middleBannerAds || []).find(function (a) {
                  return a.positionId === positionMap[SIDEBAR];
                });

                if (sideItem) {
                  _this10.sideList = sideItem.adVOList.map(function (a, index) {
                    var positonType = a.positonType,
                        mainContent = a.mainContent,
                        mainImg = a.mainImg;
                    var jumpUrl = ''; // 活动

                    if (positonType === '2') {
                      jumpUrl = mainContent;
                    } else if (positonType === '1') {
                      // 项目id
                      jumpUrl = "/myshow/#/detail/".concat(mainContent);
                    }

                    a.link = jumpUrl;
                    a.thumb = mainImg;
                    a.dataSeed = {
                      bid: 'b_movie_zqqyt5zx_mc',
                      viewBid: 'b_movie_zqqyt5zx_mv',
                      custom: {
                        index: index
                      }
                    };
                    return a;
                  });
                } // 根据项目id,获取项目详情


                recommendIdList = [];
                positionAdMap = {}; // 推荐位的处理

                recommendAds = totalList[0] && totalList[0].recommendAds || [];
                recommendAds.forEach(function (a) {
                  positionAdMap[a.positionId] = a.adVOList.map(function (a) {
                    var positonType = a.positonType,
                        mainContent = a.mainContent,
                        mainImg = a.mainImg;
                    var jumpUrl = ''; // 活动

                    if (positonType === '2') {
                      jumpUrl = mainContent;
                      a.posterUrl = mainImg;
                    } else if (positonType === '1') {
                      recommendIdList.push(mainContent); // 项目id

                      a.performanceId = mainContent;
                    }

                    a.jumpUrl = jumpUrl;
                    return a;
                  });
                }); // 获取项目详情列表

                if (recommendIdList.length > 0) {
                  projectList = totalList[0] && totalList[0].recommendPerformances || [];
                  Object.keys(positionAdMap).forEach(function (id) {
                    var adList = positionAdMap[id] || [];
                    adList = adList.map(function (ad) {
                      if (!ad.performanceId) return ad; // 项目推荐

                      var projectDetail = projectList.find(function (a) {
                        return a.performanceId === +ad.performanceId;
                      });

                      if (projectDetail) {
                        projectDetail.positonType = ad.positonType;
                        return projectDetail;
                      } // 项目下架


                      return null;
                    });
                    positionAdMap[id] = adList;
                  });
                }

                _this10.recommendIdList = recommendIdList;
                _ref6 = totalList[2] || {}, data = _ref6.data, code = _ref6.code, paging = _ref6.paging, attrMaps = _ref6.attrMaps;

                _this10.ABtestReport(attrMaps);

                data = data || [];

                if (data && data.length > 0) {
                  // 推荐位和推荐列表的去重
                  data = data.filter(function (a) {
                    return !recommendIdList.includes("".concat(a.performanceId));
                  }); // 推荐位3的替换

                  item3 = positionAdMap[positionMap[RECOMMENDATION_3]];

                  if (item3 && item3.length > 0) {
                    resouce = item3[0];

                    if (resouce) {
                      resouce.dataSeed = {
                        bid: 'b_movie_9g4yfmzc_mc',
                        viewBid: 'b_movie_9g4yfmzc_mv',
                        custom: {
                          index: 2,
                          type: resouce.discountTag ? 1 : 0,
                          custom: {
                            style: resouce.positonType === "1" ? 1 : 0,
                            performance_id: resouce.performanceId
                          }
                        }
                      };
                    }

                    data.splice(3, 0, item3[0]);
                  } // 推荐位2的替换


                  item2 = positionAdMap[positionMap[RECOMMENDATION_2]];

                  if (item2 && item2.length > 0) {
                    _resouce = item2[0];

                    if (_resouce) {
                      _resouce.dataSeed = {
                        bid: 'b_movie_9g4yfmzc_mc',
                        viewBid: 'b_movie_9g4yfmzc_mv',
                        custom: {
                          index: 1,
                          type: _resouce.discountTag ? 1 : 0,
                          custom: {
                            style: _resouce.positonType === "1" ? 1 : 0,
                            performance_id: _resouce.performanceId
                          }
                        }
                      };
                    }

                    data.splice(2, 0, item2[0]);
                  } // 推荐位1的替换


                  item1 = positionAdMap[positionMap[RECOMMENDATION_1]];

                  if (item1 && item1.length > 0) {
                    _resouce2 = item1[0];

                    if (_resouce2) {
                      _resouce2.dataSeed = {
                        bid: 'b_movie_9g4yfmzc_mc',
                        viewBid: 'b_movie_9g4yfmzc_mv',
                        custom: {
                          index: 0,
                          type: _resouce2.discountTag ? 1 : 0,
                          custom: {
                            style: _resouce2.positonType === "1" ? 1 : 0,
                            performance_id: _resouce2.performanceId
                          }
                        }
                      };
                    }

                    data.splice(1, 0, item1[0]);
                  } // 过滤为空的数据


                  data = data.filter(function (a) {
                    return !!a;
                  });
                }

                recommendList = _this10.projectUnion(data); // 设置默认海报图

                recommendList = _this10.defaultPoster(recommendList);
                _this10.hasMore = paging && paging.hasMore;
                recommendListLeft = [];
                recommendListRight = [];
                _this10.isLoading = true;
                index = 0;

              case 39:
                if (!(index < recommendList.length)) {
                  _context10.next = 55;
                  break;
                }

                try {
                  // 打点
                  if (!recommendList[index].dataSeed) {
                    // 项目的打点
                    recommendList[index].dataSeed = {
                      bid: 'b_movie_lrqkce7a_mc',
                      viewBid: 'b_movie_lrqkce7a_mv',
                      custom: {
                        type: recommendList[index].discountTag ? 1 : 0,
                        index: index,
                        custom: {
                          performance_id: recommendList[index].performanceId
                        }
                      }
                    };
                  }
                } catch (e) {}

                if (!(index !== recommendList.length - 1 && index % 2 === 0)) {
                  _context10.next = 45;
                  break;
                }

                recommendListLeft.push(recommendList[index]);
                _context10.next = 52;
                break;

              case 45:
                if (!(index !== recommendList.length - 1 && index % 2 === 1)) {
                  _context10.next = 49;
                  break;
                }

                recommendListRight.push(recommendList[index]);
                _context10.next = 52;
                break;

              case 49:
                _context10.next = 51;
                return _this10.getBoxHeight(recommendListLeft, recommendListRight);

              case 51:
                leftHeight <= rightHeight ? recommendListLeft.push(recommendList[index]) : recommendListRight.push(recommendList[index]);

              case 52:
                index++;
                _context10.next = 39;
                break;

              case 55:
                _this10.hasMore = paging && paging.hasMore;
                _this10.recommendListLeft = recommendListLeft;
                _this10.recommendListRight = recommendListRight;
                _this10.isLoading = false;
              // 暂时不考虑预加载效果
              // this.getRecommendList(2, 10) // 预加载第二屏

              case 59:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }))();
    },
    ABtestReport: function ABtestReport(attrMaps) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        var personalizedRec, recStrategy, abtest, type;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                if (attrMaps) {
                  _context11.next = 2;
                  break;
                }

                return _context11.abrupt("return");

              case 2:
                personalizedRec = attrMaps.personalizedRec, recStrategy = attrMaps.recStrategy;
                abtest = recStrategy === 2 ? 1 : 0;
                type = personalizedRec === 2 ? 1 : 0; // expId, expStrategy, personalizedRec, recStrategy, https://wiki.maoyan.com/pages/viewpage.action?pageId=200888250
                // abtest 标记abtest分组信息，0-未命中实验，1-命中实验
                // type 是否个性化用户，0-非个性化，1-个性化

                window.seedAction({
                  bid: 'b_movie_usyyk9ev_mv',
                  evt: 'view',
                  custom: {
                    abtest: abtest,
                    type: type,
                    custom: {
                      abtest: abtest,
                      type: type
                    }
                  }
                });

              case 6:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }))();
    }
  })
};